// PDFEditor.js
import React, { useState } from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const PDFEditor = () => {
  const [pdfData, setPdfData] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [editedBlobUrl, setEditedBlobUrl] = useState(null);

  // Handle PDF Upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const arrayBuffer = await file.arrayBuffer();
    setPdfData(arrayBuffer);

    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
    setPreviewUrl(URL.createObjectURL(blob));
  };

  // Edit PDF: Add Text & Image
  const editPDF = async () => {
    if (!pdfData) return;

    const pdfDoc = await PDFDocument.load(pdfData);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // Add text
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    firstPage.drawText('Text inserted via React + pdf-lib', {
      x: 50,
      y: 600,
      size: 20,
      font,
      color: rgb(0.2, 0.1, 0.6),
    });

    // Add image
    const jpgImageBytes = await fetch('/logo.jpg').then((res) => res.arrayBuffer()); // Replace with your image
    const jpgImage = await pdfDoc.embedJpg(jpgImageBytes);
    firstPage.drawImage(jpgImage, {
      x: 50,
      y: 500,
      width: 100,
      height: 100,
    });

    // Save edited PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    setEditedBlobUrl(url);
    setPreviewUrl(url); // Show updated preview
  };

  return (
    <div>
    <div>
      <h2>PDF Editor</h2>

      <input type="file" accept="application/pdf" onChange={handleFileChange} />

      {previewUrl && (
        <div style={{ height: '500px', border: '1px solid #ccc', marginTop: '1rem' }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer fileUrl={previewUrl} />
          </Worker>
        </div>
      )}

      <div style={{ marginTop: '1rem' }}>
        <button onClick={editPDF} disabled={!pdfData}>
          Edit PDF (Insert Text & Image)
        </button>

        {editedBlobUrl && (
          <a href={editedBlobUrl} download="edited.pdf" style={{ marginLeft: '1rem' }}>
            Download Edited PDF
          </a>
        )}
      </div>
    </div>
    <div className="content">

  <h2>Edit PDF: Modify Your Documents with Ease</h2>

  <p>
    PDFs are often seen as read-only files, but with the Edit PDF tool, you can 
    easily make changes to your documents without converting them to another format. 
    Whether you need to update text, add images, annotate, or adjust layouts, this 
    tool gives you complete control over your PDF content.
  </p>

  <p>
    Editing PDFs ensures your documents remain accurate, up-to-date, and professional 
    without the hassle of recreating files from scratch.
  </p>

  <h3>Why Edit PDFs?</h3>

  <ul>
    <li>Correct errors or update outdated information</li>
    <li>Add or remove text, images, and graphics</li>
    <li>Annotate documents for collaboration or review</li>
    <li>Adjust layout and formatting for better readability</li>
    <li>Save time by editing directly in the PDF</li>
  </ul>

  <h3>How the PDF Editing Process Works</h3>

  <h4>1. Upload Your PDF</h4>
  <p>
    Start by selecting the PDF you want to edit. The tool loads the file and 
    displays all pages for easy editing.
  </p>

  <h4>2. Edit Text and Images</h4>
  <p>
    Click on text to modify, delete, or add new content. Insert images, logos, 
    or charts wherever needed. All changes retain the original formatting 
    and layout.
  </p>

  <h4>3. Annotate and Highlight</h4>
  <p>
    Use annotation tools to highlight important sections, add comments, 
    draw shapes, or underline key information. Perfect for collaboration 
    or review purposes.
  </p>

  <h4>4. Rearrange or Delete Pages</h4>
  <p>
    Organize your PDF by moving pages, deleting unnecessary ones, or 
    rotating them to improve document flow.
  </p>

  <h3>Your Final Edited PDF</h3>
  <p>
    Once your edits are complete, save the PDF. The resulting file preserves 
    the original quality, layout, and design, with all your updates applied 
    seamlessly. It’s ready for sharing, printing, or archiving.
  </p>

</div>

    </div>
  );
};

export default PDFEditor;
// PDFEditor.js